import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  extractSelectedTicketFromState,
  getActionReasons,
  getDecisionNodeAtPath,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { AVAILABLE_FIELDS_CONFIG, DTSelectActionReasonView } from '../../DTSelectActionReasonView';
import SelectInputs from '../../Common/SelectInputs/SelectInputs';
import { storeLastMileData } from '../../../../../../actions/tools/LastMileActions';

const DTSelectReasonForLastMileNode = () => {
  const dispatch = useDispatch();

  const actionReasons = useSelector(getActionReasons);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const selectedTicket = useSelector(extractSelectedTicketFromState);
  const decisionNode = useSelector(getDecisionNodeAtPath);

  const [options, setOptions] = useState(null);

  const handleNextButtonClick = async () => {
    const { lastMileSettings = {} } = decisionNode;
    await dispatch(
      storeLastMileData(simplrAccountId, selectedTicket.ticketId, actionReasons?.refundPrimaryReason, lastMileSettings)
    );
    dispatch(addEdgeToDecisionTreePath('reason_selected'));
  };

  useEffect(() => {
    const { lastMileSettings = {} } = decisionNode;
    const { optionsData = {} } = lastMileSettings;
    setOptions(optionsData);
  }, [decisionNode]);

  return (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.refundPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputs
        placeholder="Select refund reason"
        options={options}
        fields={AVAILABLE_FIELDS_CONFIG.refundPrimaryReason}
        isCustomOption={true}
      />
    </DTSelectActionReasonView>
  );
};

export default DTSelectReasonForLastMileNode;
